<div class="notifications">
  <div class="row notification-header">
    <div *ngIf="notifications.length > 0; then hasNotifications; else noNotifications"></div>
    <ng-template #hasNotifications>
      <div class="col-5 notification-icon text-left">
        <a href="javascript:void(0);" (click)="dismissAll()">
          Dismiss All
        </a>
      </div></ng-template
    >
    <ng-template #noNotifications> <div class="col-1 notification-icon"></div></ng-template>

    <div class="notification-text" [ngClass]="notifications.length > 0 ? 'col-6 text-left' : 'col'">
      Notifications
    </div>
    <div class="col-1 notification-text">
      <button class="close-btn" type="button" hbAppAsideMenuToggler>
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
  <hb-notification *ngFor="let notification of notifications" [notification]="notification"></hb-notification>
</div>
